var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Iconly/Bulk/Arrow - Down Circle"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Arrow - Down Circle"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 1",
    d: "M25 12.5A12.5 12.5 0 1 1 12.5 0 12.513 12.513 0 0 1 25 12.5",
    style: {
      fill: "#151aae"
    },
    transform: "rotate(-90 12.5 12.5)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 4",
    d: "M10.553.937a.933.933 0 0 1-.274.661L5.942 5.957a.94.94 0 0 1-1.329 0L.273 1.6A.937.937 0 0 1 1.6.275l3.677 3.692L8.952.275a.937.937 0 0 1 1.6.661",
    transform: "rotate(-90 13.769 4.009)",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownCircle);
export default __webpack_public_path__ + "static/media/Arrow_Down_Circle.e512fd6694bd93852b8549b35c3f2e83.svg";
export { ForwardRef as ReactComponent };